class RouteStore extends FluxBaseStore
  @storeName: 'RouteStore'

  @handlers:
    SET_PARAM:     'gotoSearch'
    SET_PARAMS:    'gotoSearch'
    TOGGLE_FACET:  'gotoSearch'
    HIDE_RESOURCE: 'gotoSearchFromModal'
    SHOW_RESOURCE: 'gotoResource'
    CLEAR_ALL:     'gotoSearch'

  initialize: ->
    @dispatcherInitiatedStateChange = false

  setSearchPath: ({url, title}) ->
    @searchPath = url: url, title: title

  gotoSearch: (payload) ->
    if payload && payload.noHistory
      return true

    @dispatcher.waitFor 'ParamStore', @gotoSearchFromModal

  gotoSearchFromModal: (payload) =>
    if (payload && payload.fromBackButton)
      return true;

    if @searchPath?
      @_goto url: @searchPath.url, title: @searchPath.title
    else
      paramStore = @dispatcher.getStore 'ParamStore'
      @_goto url: LP.config.search_path + paramStore.toQueryString(), title: paramStore.title()

  gotoResource: (payload) ->
    return if payload.fromBackButton
    @_goto payload

  _goto: ({url, title}) ->
    @dispatcherInitiatedStateChange = true
    window.history.pushState(null, title, url)
    @dispatcherInitiatedStateChange = false

LP.module('Searches').RouteStore = RouteStore
